module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cp_gaseosas_lata_220_ccso.d4ea1644.png";